module.exports = __webpack_public_path__ + "img/c5202009-1.73ae4a22.jpg";